import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

// grid-event.service.ts
@Injectable({ providedIn: 'root' })
export class GridEventService {
  private calculateScoresSubject = new Subject<void>();
  calculateScores$ = this.calculateScoresSubject.asObservable();

  requestCalculateScores() {
    this.calculateScoresSubject.next();
  }
}
